import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { FileImage } from '~/views/molecules/file-image';
import { EFileExtension, EFileSize, EFileType, FILE_WITH_COPYRIGHT_PREFIX } from '~/shared/types';
import { getCoverLink, getFileLink } from '~/tools/file';
import { useService } from '~/services/service.base';
import { ServiceConfig } from '~/services/service.config';
import { observer } from 'mobx-react-lite';
import { Grid, Typography } from '@mui/material';
import { ServiceFileSaver } from '~/services/service.file.saver';
export const BookSheetContentDocument = observer(({ document: documentObj }) => {
    const serviceConfig = useService(ServiceConfig);
    const serviceFileSaver = useService(ServiceFileSaver);
    const downloadHandler = useCallback(() => {
        const link = documentObj?.objType === EFileType.image
            ? documentObj?.path + '_' + EFileSize.large + FILE_WITH_COPYRIGHT_PREFIX
            : documentObj?.path || '';
        serviceFileSaver.save(getFileLink(link, serviceConfig.awsUrl, documentObj?.fileExtension || EFileExtension.jpg, documentObj?.objType || EFileType.archive), documentObj?.name || '');
    }, [documentObj, serviceConfig.awsUrl, serviceFileSaver]);
    return (_jsxs(Grid, { container: true, direction: "row", onClick: () => downloadHandler(), children: [_jsx(Grid, { container: true, xs: 2, item: true, alignItems: "center", children: _jsx(FileImage, { item: {
                        extension: documentObj?.fileExtension || EFileExtension.zip,
                        title: documentObj?.name || '',
                        fileType: documentObj?.objType || EFileType.archive,
                        depository: '',
                        id: String(documentObj?.id || ''),
                        date: String(documentObj?.cdate || ''),
                        eventLocation: '',
                        author: '',
                        physicalForm: '',
                        physicalFormCode: '',
                        userId: String(documentObj?.userId || ''),
                        img: getCoverLink(documentObj?.path || '', serviceConfig.awsUrl, '', `_${EFileSize.big}`),
                        name: documentObj?.name || '',
                    } }) }), _jsx(Grid, { px: 1, container: true, item: true, xs: 10, alignItems: "center", children: _jsxs(Typography, { variant: "body1", children: [documentObj?.name, documentObj?.fileExtension ? '.' + documentObj?.fileExtension : ''] }) })] }));
});
